import { PIN_PRIVATE_STATUS } from "@/constants/pin";
import useAppStore from "@/context/store";
import { getBoardsListByIds } from "@/services";
import { filterBoards } from "@/utils/filterBoards";
import imageUrl from "@/utils/imageUrl";
import { isEnter, isEsc } from "@/utils/keyBoard";
import sortBoardsByTitleAndCreateTime, {
  setBoardsTitlePinyin,
} from "@/utils/sortBoardsByTitleAndCreateTime";
import useOuterClick from "@/utils/useOuterClick";
import useRequest from "@/utils/useReq";
import { useMemoizedFn, useMount, useSafeState } from "ahooks";
import { Dropdown } from "antd";
import classNames from "classnames";
import _ from "lodash";
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { Else, If, Then, When } from "react-if";
import CreateBoard from "../CreateBoard";
import HBIcon from "../HBIcon";
import HBLoading from "../HBLoading";
import Image from "../Image";
import { Violation } from "../Violation";
import { useIsViolationAb } from "../Violation/useIsViolationAb";
import BoardSelectBoardList from "./BoardSelectBoardList";
import styles from "./index.module.less";

function MutiBoardSelect(
  {
    value: _value,
    onChange: _onChange,
    placeholder,
    useLabel,
    useCreation,
    onlyCreation,
    boardDataMap,
    labelRender,
  },
  ref
) {
  const [value, setValue] = useSafeState(null);
  const [keyword, setKeyword] = useState("");
  const menuRef = useRef(null);
  const onChange = useMemoizedFn((value, changeValue) => {
    return (
      _onChange &&
      _onChange(
        (value || []).map((board) => board.board_id).join(),
        changeValue
      )
    );
  });
  const { lastBoards: userBoards, setLastBoards } = useAppStore(
    ({ lastBoards, setLastBoards }) => ({ lastBoards, setLastBoards })
  );

  const { data: boardData, loading: boardLoading } = useRequest(
    async () => {
      // const result = await getLastBoards();
      // 将画板增加拼音
      let boardList = userBoards;
      if (boardList?.length > 0 && !boardList?.[0]?._pinyin) {
        boardList = await setBoardsTitlePinyin(boardList);
        setLastBoards(boardList);
        return;
      }
      // 过滤原创画板
      let boards = boardList;
      if (!useCreation) {
        boards = boardList?.filter((board) => !board?.extra?.is_creation) || [];
      } else if (onlyCreation) {
        boards = boardList?.filter((board) => board?.extra?.is_creation) || [];
      }
      // 为画板添加首字母与拼音
      const withPinyinBoards = boards.map((board) => {
        const item = { ...board };
        let firstLetter =
          item._pinyin.length > 0
            ? `${
                item._pinyin[0].length > 0
                  ? item._pinyin[0][0]
                  : item._pinyin[0]
              }`.toLocaleUpperCase()
            : "";
        if (!/[A-Z]/.test(firstLetter)) {
          firstLetter = "#";
        }
        item._firstLetter = firstLetter;
        return item;
      });
      // 前5个画板作为历史画板
      // const lastBoards = withPinyinBoards
      //   .slice(0, LAST_BOARD_NUM)
      //   .map((board, index) => {
      //     const item = {
      //       ...board,
      //     };
      //     if (index === 0) {
      //       item._icon = "time";
      //     }
      //     return item;
      //   });
      // 剩余画板按字母排序
      const otherBoards = Object.entries(
        _.groupBy(
          sortBoardsByTitleAndCreateTime(withPinyinBoards),
          "_firstLetter"
        )
      )
        .sort((a, b) => `${a[0]}`.charCodeAt() - `${b[0]}`.charCodeAt())
        .reduce((result, [firstLetter, group]) => {
          result = result.concat(
            group.map((board, index) => {
              const item = { ...board };
              if (index === 0) {
                item._icon = firstLetter;
              }
              return item;
            })
          );
          return result;
        }, []);

      return {
        groupByLetterBoards: [...otherBoards],
        withPinyinBoards,
      };
    },
    {
      manual: false,
      refreshDeps: [userBoards],
    }
  );

  const dataSource = useMemo(() => {
    if (!keyword) {
      return (boardData?.groupByLetterBoards || []).map((board) => {
        if (value && value.find((item) => item.board_id === board.board_id)) {
          board.checked = true;
        } else {
          board.checked = false;
        }
        board = boardDataMap && boardDataMap(board);
        return board;
      });
    }
    let boards = filterBoards(keyword, boardData);
    return boards.map((board, index) => {
      if (value && value.find((item) => item.board_id === board.board_id)) {
        board.checked = true;
      } else {
        board.checked = false;
      }

      let item = { ...board };
      if (index === 0) {
        item._icon = "search";
      }

      item = boardDataMap && boardDataMap(item);

      return item;
    });
  }, [boardData, keyword, value, boardDataMap]);

  const updateValueByIds = useMemoizedFn(async () => {
    if (_value) {
      if (
        value?.length &&
        value.map((item) => item.board_id).join() === _value
      ) {
        return value;
      }
      if (_value) {
        const { boards, err } = await getBoardsListByIds(_value.split(","), 1);
        if (err) {
          return;
        }
        setValue(boards.filter((v) => v));
      }
    } else {
      setValue([]);
    }

    return null;
  });

  useEffect(() => {
    updateValueByIds();
  }, [_value, updateValueByIds]);

  const onDropdownVisibleChange = useCallback(
    async (open) => {
      if (open && !boardData) {
        // runGetBoards();
        useAppStore.getState().refreshLastBoards();
      }
    },
    [boardData]
  );

  const onSearch = useCallback((keyword) => {
    setKeyword(keyword);
  }, []);

  const onSelect = useMemoizedFn((board) => {
    const nextValue = value
      ? value.find((item) => item.board_id === board.board_id)
        ? value.filter((item) => item.board_id !== board.board_id)
        : [board, ...value]
      : [board];
    setValue(nextValue);
    onChange && onChange(nextValue, board);
  });

  const onCreate = useCallback(() => {
    // runGetBoards();
    // useAppStore.getState().refreshLastBoards();
    menuRef.current?.scrollTo(0, 0);
  }, []);

  const onClear = useCallback(() => {
    setValue(null);
    onChange && onChange(null, null);
  }, [onChange, setValue]);

  const dropdownRender = useCallback(() => {
    return (
      <div className={styles.list}>
        <div className={styles.header}>输入名称，搜索画板</div>
        <If condition={boardLoading && !boardData}>
          <Then>
            <div className={styles.loading}>
              <HBLoading size="24px" />
            </div>
          </Then>
          <Else>
            <If condition={dataSource.length <= 0}>
              <Then>
                <div className={styles.empty}>
                  <div className={styles.img}>
                    <img
                      src="//cdn.dancf.com/fe-assets/img/a52cf2370b7c7f53c751dfcd154fcbde.png"
                      alt="还没有画板哦～"
                    />
                  </div>
                  <div className={styles.text}>还没有画板哦～</div>
                </div>
              </Then>
              <Else>
                <BoardSelectBoardList
                  ref={menuRef}
                  dataSource={dataSource}
                  onSelect={onSelect}
                  multiple
                />
              </Else>
            </If>
          </Else>
        </If>
        <div className={styles.footer}>
          <div className={styles.split}></div>
          <CreateBoard
            onCreate={onCreate}
            useCreation={useCreation}
            boardName={keyword}
          />
        </div>
      </div>
    );
  }, [
    boardLoading,
    boardData,
    dataSource,
    onSelect,
    onCreate,
    useCreation,
    keyword,
  ]);

  // const options = useMemo(() => {
  //   return dataSource.map((board) => ({
  //     label: board?.title,
  //     value: board?.board_id,
  //   }));
  // }, [dataSource]);

  useImperativeHandle(ref, () => {
    return {
      refresh: useAppStore.getState().refreshLastBoards,
    };
  });

  // 初始化时获取最新的画板，保证能拿到最新的画板列表数据
  useMount(() => {
    useAppStore.getState().refreshLastBoards();
  });

  const violationAb = useIsViolationAb();

  const tagRender = useMemoizedFn((board) => {
    const coverPin = board.cover || (board.pins || [])[0];
    return (
      <div className={styles.selectItem} key={board.board_id}>
        {coverPin ? (
          violationAb.new &&
          coverPin.is_private === PIN_PRIVATE_STATUS.VIOLATION ? (
            <Violation
              hideText
              iconSize={14}
              style={{ width: 32, height: 32 }}
            />
          ) : (
            <Image
              alt={"cover"}
              src={imageUrl(coverPin.file, { width: 32 })}
              width={32}
              height={32}
            />
          )
        ) : (
          <div className={styles.imgBlock}>
            <HBIcon type="ic_logo" />
          </div>
        )}
        <div className={styles.name}>{board.title}</div>
        <HBIcon
          className={styles.closeIcon}
          type="ic_close"
          onClick={(e) => {
            e.stopPropagation();
            onSelect(board);
          }}
        />
      </div>
    );
  });

  return (
    <div
      className={classNames([
        styles.container,
        value || keyword ? styles.hasValue : null,
      ])}
    >
      {useLabel ? (
        <When condition={useLabel && placeholder}>
          <div className={styles.placeholder}>{placeholder}</div>
        </When>
      ) : (
        labelRender && labelRender(value)
      )}

      <CustomSelect
        value={value}
        dropdownRender={dropdownRender}
        dropdownClassName={styles.dropdown}
        onDropdownVisibleChange={onDropdownVisibleChange}
        onSearch={onSearch}
        onClear={onClear}
        placeholder={useLabel ? "" : placeholder}
        tagRender={tagRender}
      />
    </div>
  );
}

export default forwardRef(MutiBoardSelect);

function CustomSelect({
  value,
  placeholder,
  onSearch,
  dropdownRender,
  dropdownClassName,
  onDropdownVisibleChange,
  // onClear,
  tagRender,
}) {
  // const [selectValue, setValue] = useControllableValue({ value });
  // const [isFocus, setFocus] = useSafeState(false);
  const inputRef = useRef();
  const dropDownRef = useRef();
  const [ref, dropdownVisible, setDropdownVisble] = useOuterClick(false, {
    extraTargets: [dropDownRef],
  });

  const toggleVisible = useMemoizedFn((e) => {
    e.stopPropagation();
    setDropdownVisble(!dropdownVisible);
  });

  const onClick = useMemoizedFn(() => {
    setDropdownVisble(true);

    // 将光标聚焦到文本最后位置  focus()方法不会聚焦到最后
    // inputRef.current.focus();
    setTimeout(() => {
      if (inputRef.current) {
        const range = document.createRange();
        range.selectNodeContents(inputRef.current);
        range.collapse(false);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }, 200);
  });

  const onInput = useMemoizedFn((e) => {
    onSearch(e.target.innerText);
  });

  // const onBlur = useMemoizedFn((e) => {
  //   console.log("onBlur - e", e)
  //   setFocus(false);
  // });

  const dropdownContent = useMemo(() => {
    return <div ref={dropDownRef}> {dropdownRender()} </div>;
  }, [dropdownRender]);

  const inputOnKeyDown = useMemoizedFn((e) => {
    e.stopPropagation();

    if (isEnter(e)) {
      e.preventDefault();
    }

    if (isEsc(e)) {
      setDropdownVisble(false);
    }
  });

  useEffect(() => {
    if (!dropdownVisible) {
      inputRef.current.innerText = "";
      onSearch("");
    }
  }, [dropdownVisible, onSearch]);

  return (
    <div
      className={classNames(styles.CustomSelect, "thin-scroll-bar", {
        [styles.focus]: dropdownVisible,
      })}
      onClick={onClick}
      // onBlur={onBlur}
      ref={ref}
    >
      <Dropdown
        visible={dropdownVisible}
        overlay={dropdownContent}
        overlayClassName={classNames(dropdownClassName, styles.dropdownWrap)}
        onVisibleChange={onDropdownVisibleChange}
        align={{ offset: [-12, 16] }}
        // destroyPopupOnHide
      >
        <div
          className={styles.input}
          ref={inputRef}
          contentEditable="plaintext-only"
          onInput={onInput}
          onKeyDown={inputOnKeyDown}
          style={{ padding: dropdownVisible ? "0 8px 0 0" : "0" }}
        ></div>
      </Dropdown>

      {Array.isArray(value) ? value.map(tagRender) : value}

      {(value && value.length) || dropdownVisible ? null : (
        <div className={styles.selectPlaceholder}>{placeholder}</div>
      )}

      <HBIcon
        onClick={toggleVisible}
        className={classNames(styles.arrowIcon, {
          [styles.up]: dropdownVisible,
        })}
        type="arrow_up"
      />
    </div>
  );
}
